import styled from 'styled-components'

export const StyledErrorMessage = styled.div`
  margin: ${({ theme: { layout } }) => layout.spacing(2)} 0 0 0;
  color: ${({ theme: { colors } }) => colors.error};
  font-size: ${({ theme: { fontSize } }) => fontSize.small};
`
